import { observer } from 'mobx-react'
import { Route, Routes } from 'react-router-dom'
import { Route as RouteDefinition } from '../../pages/routes'
import { RouteWrapper } from './route-wrapper'

interface Props {
    routes: RouteDefinition[]
}

export const Router: React.FC<Props> = observer(({ routes }) => {
    return (
        <Routes>
            {routes.map(([paths, title, component, authRequirements], i) => {
                return paths.map((path, j) => {
                    return (
                        <Route
                            key={`${i}${j}`}
                            path={path}
                            element={
                                <RouteWrapper
                                    title={title}
                                    path={path}
                                    component={component}
                                    authRequirements={authRequirements}
                                />
                            }
                        />
                    )
                })
            })}
        </Routes>
    )
})
